import { gql } from '@apollo/client'
import { TERRA_PROVIDER } from '@src/graphql/fragments/terraProvider'

export const DEAUTH_TERRA_PROVIDER = gql`
  ${TERRA_PROVIDER}
  mutation deauthTerraProvider($provider: String!) {
    deauthTerraProvider(provider: $provider) {
      providers {
        ...TerraProvider
      }
    }
  }
`
